import React, {Component} from "react";

export default class UAjudge extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copySuccess: ''
    }

  }

  copyToClipboard = (e) => {
    var copyText = document.querySelector('.js-copytext');
    var range = document.createRange();
    range.selectNode(copyText);
    window.getSelection().addRange(range);
    try {
      var successful = document.execCommand('copy');
      var msg = successful
        ? 'successful'
        : 'unsuccessful';
      console.log('Copy command was ' + msg);
      alert('コピーしました');
    } catch (err) {
      console.log('Oops, unable to copy');
    }
    window.getSelection().removeAllRanges();
  };

  render() {
    const ua = navigator.userAgent.toLowerCase();
    const isIOS = /ip(hone|od|ad)/.test(ua);
    const isAndroid = /android/.test(ua);
    const isLine = /line/.test(ua);
    const isFacebook = /fb/.test(ua);
    const isYahoo = (ua.indexOf('yahoo') !== -1);
    const isYahooMail = (ua.indexOf('ymail') !== -1);
    const isGmail = (ua.indexOf('CriOS') !== -1);


    return (
      <div>
      {
        (() => {
          if (isIOS ) {

            if ( isYahooMail) {
              return (<div className="ua_bg">
                <div className="ua_box">
                  <div className="text-center"><img src={require("../images/login/ua_logo.png")} alt="GeneLife" width="120"/></div>
                  <p>現在のブラウザでは、一部の仕様が正常に処理されない可能性がございます。以下の手順に沿って、Safariのご利用をお願いいたします。</p>
                <h4>手順</h4>
                  <ul>
                    <li>①以下のマークをタップ<br />
                  <div className="text-center"><img src={require("../images/login/ua_ymail.png")} alt="Yahooブラウザ" width="230"/></div>
                </li>
                    <li>②「Safariで開く」を選択</li>
                    </ul>

                </div>
              </div>)
            }

            if (isYahoo) {
              return (<div className="ua_bg">
                <div className="ua_box">
                  <div className="text-center"><img src={require("../images/login/ua_logo.png")} alt="GeneLife" width="120"/></div>
                  <p>現在のブラウザでは、一部の仕様が正常に処理されない可能性がございます。以下の手順に沿って、Safariのご利用をお願いいたします。</p>
                <h4>手順</h4>
                  <ul>
                    <li>①以下のマークをタップ<br />
                  <div className="text-center"><img src={require("../images/login/ua_yahoo.png")} alt="Yahooブラウザ" width="230"/></div>
                </li>
                    <li>②「Safariで開く」を選択</li>
                    </ul>

                </div>
              </div>)
            }

            if (isLine) {
              return (<div className="ua_bg">
              <div className="ua_box">
                <div className="text-center"><img src={require("../images/login/ua_logo.png")} alt="GeneLife" width="120"/></div>
                <p>現在のブラウザでは、一部の仕様が正常に処理されない可能性がございます。以下の手順に沿って、Safariのご利用をお願いいたします。</p>
              <h4>手順</h4>
                <ul>
                  <li>①右上の<img src={require("../images/login/ua_open.png")} alt="open" width="30"/>マークをタップ<br />
              </li>
                  <li>②「Safariで開く」を選択</li>
                  </ul>
              </div>
              </div>)
            }
            if (isFacebook) {
              return (<div className="ua_bg">
              <div className="ua_box">
                <div className="text-center"><img src={require("../images/login/ua_logo.png")} alt="GeneLife" width="120"/></div>
                <p>現在のブラウザでは、一部の仕様が正常に処理されない可能性がございます。以下の手順に沿って、Safariのご利用をお願いいたします。</p>
              <h4>手順</h4>
                <ul>
                  <li>①下部の<img src={require("../images/login/ua_open.png")} alt="open" width="30"/>マークをタップ<br />
              </li>
                  <li>②「Safariで開く」を選択</li>
                  </ul>
              </div>
              </div>)
            }
            if (isGmail) {
              return (<div className="ua_bg">
              <div className="ua_box">
                <div className="text-center"><img src={require("../images/login/ua_logo.png")} alt="GeneLife" width="120"/></div>
                <p>現在のブラウザでは、一部の仕様が正常に処理されない可能性がございます。以下の手順に沿って、Safariのご利用をお願いいたします。</p>
              <h4>手順</h4>
                <ul>
                  <li>①下部の<img src={require("../images/login/ua_open.png")} alt="open" width="30"/>マークをタップ<br />
              </li>
                  <li>②「Safariで開く」を選択</li>
                  </ul>
              </div>
              </div>)
            }
          }


          if (isAndroid) {
            if  (isYahoo || isYahooMail) {
              return (<div className="ua_bg">
                <div className="ua_box">
                  <div className="text-center"><img src={require("../images/login/ua_logo.png")} alt="GeneLife" width="120"/></div>
                  <p>現在のブラウザでは、一部の仕様が正常に処理されない可能性がございます。以下の手順に沿って、Google Chromeのご利用をお願いいたします。</p>
                <h4>手順</h4>
                  <ul>
                    <li>①Google Chromeを開いてください<br />
                    <img src={require("../images/login/ua_chrome.png")} alt="chrome"  width="60"/>
                </li>
                    <li>②「遺伝子検査のジーンライフ」を検索してください</li>
                    <li>
                      ③https://genelife.jp/にアクセスし、「ログイン」をタップしてください
                      <div className="text-center"><img src={require("../images/login/ua_genelife.png")} alt="genelife"  /></div>
                    </li>
                    </ul>

                </div>
              </div>)
            }
            if (isLine) {
              return (<div className="ua_bg">
              <div className="ua_box">
                <div className="text-center"><img src={require("../images/login/ua_logo.png")} alt="GeneLife" width="120"/></div>
                <p>現在のブラウザでは、一部の仕様が正常に処理されない可能性がございます。以下の手順に沿って、Google Chromeのご利用をお願いいたします。</p>
              <h4>手順</h4>
                <ul>
                  <li>①Google Chromeを開いてください<br />
                  <img src={require("../images/login/ua_chrome.png")} alt="chrome"  width="60"/>
              </li>
                  <li>②「遺伝子検査のジーンライフ」を検索してください</li>
                  <li>
                    ③https://genelife.jp/にアクセスし、「ログイン」をタップしてください
                    <div className="text-center"><img src={require("../images/login/ua_genelife.png")} alt="genelife"  /></div>
                  </li>
                  </ul>

              </div>
              </div>)
            }
            if (isFacebook) {
              return (<div className="ua_bg">
              <div className="ua_box">
                <div className="text-center"><img src={require("../images/login/ua_logo.png")} alt="GeneLife" width="120"/></div>
                <p>現在のブラウザでは、一部の仕様が正常に処理されない可能性がございます。以下の手順に沿って、Google Chromeのご利用をお願いいたします。</p>
              <h4>手順</h4>
                <ul>
                  <li>①Google Chromeを開いてください<br />
                  <img src={require("../images/login/ua_chrome.png")} alt="chrome"  width="60"/>
              </li>
                  <li>②「遺伝子検査のジーンライフ」を検索してください</li>
                  <li>
                    ③https://genelife.jp/にアクセスし、「ログイン」をタップしてください
                    <div className="text-center"><img src={require("../images/login/ua_genelife.png")} alt="genelife"  /></div>
                  </li>
                  </ul>

              </div>
              </div>)
            }
            if (isGmail) {
              return (<div className="ua_bg">
              <div className="ua_box">
                <div className="text-center"><img src={require("../images/login/ua_logo.png")} alt="GeneLife" width="120"/></div>
                <p>現在のブラウザでは、一部の仕様が正常に処理されない可能性がございます。以下の手順に沿って、Google Chromeのご利用をお願いいたします。</p>
              <h4>手順</h4>
                <ul>
                  <li>①Google Chromeを開いてください<br />
                  <img src={require("../images/login/ua_chrome.png")} alt="chrome"  width="60"/>
              </li>
                  <li>②「遺伝子検査のジーンライフ」を検索してください</li>
                  <li>
                    ③https://genelife.jp/にアクセスし、「ログイン」をタップしてください
                    <div className="text-center"><img src={require("../images/login/ua_genelife.png")} alt="genelife"  /></div>
                  </li>
                  </ul>

              </div>
              </div>)
            }
          }



        })()
      }
    </div>);
  }
}
